"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDafPaymentAvailable = exports.isDafEligibleOrganization = exports.countryAllowsDaf = exports.DAF_MINIMUM_AMOUNT = void 0;
const enums_1 = require("../../enums");
const country_1 = require("../enums/country");
exports.DAF_MINIMUM_AMOUNT = 100_000;
const countryAllowsDaf = (country) => country === country_1.OrganizationCountry.UnitedStates;
exports.countryAllowsDaf = countryAllowsDaf;
const isDafEligibleOrganization = (organization) => (0, exports.countryAllowsDaf)(organization.country) &&
    organization.type === enums_1.OrganizationType.Charity &&
    Boolean(organization.charityNumber?.trim() &&
        organization.address?.trim() &&
        organization.city?.trim() &&
        organization.region?.trim() &&
        organization.postalCode?.trim());
exports.isDafEligibleOrganization = isDafEligibleOrganization;
const isDafPaymentAvailable = ({ organization, formType, dafEnabled, amount, recurrenceInterval, }) => Boolean(dafEnabled) &&
    formType === enums_1.FormType.DonationForm &&
    (0, exports.isDafEligibleOrganization)(organization) &&
    recurrenceInterval === enums_1.ProductDonationRecurrenceInterval.OneTime &&
    Number.isSafeInteger(amount) &&
    amount >= exports.DAF_MINIMUM_AMOUNT;
exports.isDafPaymentAvailable = isDafPaymentAvailable;
